import React, { useState, useEffect, useRef, useCallback } from "react";
import RoomBasic from "../../assets/images/RoomBasic.png";
import DefaultCeiling from "../../assets/images/DefaultCeiling.png";
import DefaultWall from "../../assets/part_2.png";
import WallForeground from "../../assets/image 4.png";
import DefaultFloor from "../../assets/images/DefaultFloor.png";
import { useNavigate } from "react-router-dom";
import RoomDropdown from "../../components/RoomDropdown/RoomDropdown";
import Header from "../../components/Header";
import axios from "axios";
import axiosWithAuth from "../../utils/axiosWithAuth";
import { useTranslation } from "react-i18next";
import { SquareLoader } from "react-spinners";
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast } from "react-hot-toast";
import { getApiEndpoint, getImageUrl } from "../../utils/apiConfig";
import { getPublicSettings } from '../../services/settingsService';
import { calculateRepairBreakdown } from "../../services/repairService";

const Material = () => {
  const { t } = useTranslation();
  document.title = t("material.0");
  const headerTitle = t("material.0");
  const navigate = useNavigate();
  const backwardNavigate = "/dimensionroom";
  const [activeSection, setActiveSection] = useState(null);
  const [ceilingImage, setCeilingImage] = useState(DefaultCeiling);
  const [wallImage, setWallImage] = useState(DefaultWall);
  const [floorImage, setFloorImage] = useState(DefaultFloor);
  const [showFullRoomImage, setShowFullRoomImage] = useState(false);
  const [roomImage, setRoomImage] = useState(RoomBasic);
  const dropdownRef = useRef(null);
  const [materialCategory, setMaterialCategory] = useState([]);
  const [material, setMaterial] = useState([]);
  const [material1, setMaterial1] = useState([]);
  const [material2, setMaterial2] = useState([]);
  const [material3, setMaterial3] = useState([]);
  const [materialCategories, setMaterialCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [publicSettings, setPublicSettings] = useState([]);
  const selectedRepairTariff =
    JSON.parse(sessionStorage.getItem("selectedRepairTariff")) || {};
  const selectedRepairStyle =
    JSON.parse(sessionStorage.getItem("selectedRepairStyle")) || {};
  const selectedRoomTypes =
    JSON.parse(sessionStorage.getItem("roomValues")) || [];
  const [selectedRoom, setSelectedRoom] = useState(() => {
    try {
      const roomValues = JSON.parse(sessionStorage.getItem("roomValues") || "[]");
    return roomValues.length > 0 ? roomValues[0].name : "Qonaq otağı";
    } catch (error) {
      console.error("Error parsing roomValues:", error);
      return "Qonaq otağı";
    }
  });
  const [calculatedArea, setCalculatedArea] = useState(0);
  const [totalArea, setTotalArea] = useState(0);
  const [roomHeight, setRoomHeight] = useState(0);
  const [roomValues, setRoomValues] = useState([]);
  const [totalDoorCount, setTotalDoorCount] = useState(0);
  const [totalWindowCount, setTotalWindowCount] = useState(0);
  const [userInfo, setUserInfo] = useState(null);

  // Category to room part mapping - this will be populated from API data
  const [categoryRoomMapping, setCategoryRoomMapping] = useState({});

  // Function to determine room part based on category name
  const determineRoomPartFromCategory = (categoryName) => {
    if (!categoryName) return null;
    
    const name = categoryName.toLowerCase();
    
    // Tavan (Ceiling) keywords
    if (name.includes('tavan') || name.includes('ceiling') || name.includes('потолок')) {
      return 'ceiling';
    }
    
    // Divar (Wall) keywords  
    if (name.includes('divar') || name.includes('wall') || name.includes('стена') || 
        name.includes('boya') || name.includes('paint') || name.includes('краска')) {
      return 'wall';
    }
    
    // Döşəmə (Floor) keywords
    if (name.includes('döşəmə') || name.includes('floor') || name.includes('пол') ||
        name.includes('laminat') || name.includes('laminate') || name.includes('ламинат') ||
        name.includes('parket') || name.includes('parquet') || name.includes('паркет') ||
        name.includes('keramik') || name.includes('ceramic') || name.includes('керамика') ||
        name.includes('kafel') || name.includes('tile') || name.includes('плитка')) {
      return 'floor';
    }
    
    return null;
  };

  // Function to create category mapping from API data
  const createCategoryMapping = (categories) => {
    const mapping = {};
    
    categories.forEach(category => {
      const categoryName = category.name?.text || category.name?.az || category.name?.en || category.name || '';
      const roomPart = determineRoomPartFromCategory(categoryName);
      
      if (roomPart) {
        mapping[category.id] = {
          roomPart,
          categoryName,
          categoryId: category.id
        };
        
        console.log(`Mapped category "${categoryName}" (${category.id}) to room part: ${roomPart}`);
      }
    });
    
    return mapping;
  };

  // Initialize selectedMaterial with proper error handling
  const [selectedMaterial, setSelectedMaterial] = useState(() => {
    try {
      const savedMaterials = sessionStorage.getItem("selectedMaterial");
      const roomValues = JSON.parse(sessionStorage.getItem("roomValues") || "[]");
      const defaultRoom = roomValues.length > 0 ? roomValues[0].name : "Qonaq otağı";
      
      if (!savedMaterials) {
        const defaultState = { 
          roomTypes: [{ roomType: defaultRoom, materials: [] }] 
        };
        sessionStorage.setItem("selectedMaterial", JSON.stringify(defaultState));
        return defaultState;
      }
      
      const parsed = JSON.parse(savedMaterials);
      
      if (parsed.roomTypes) {
        const validRoomTypes = parsed.roomTypes
          .filter(room => room && typeof room.roomType === 'string' && room.roomType.trim())
          .map(room => ({
            roomType: room.roomType,
            materials: Array.isArray(room.materials) ? room.materials : []
          }));
        
        // Ensure at least one valid room type exists
        if (validRoomTypes.length === 0) {
          validRoomTypes.push({ roomType: defaultRoom, materials: [] });
        }
        
        const result = { roomTypes: validRoomTypes };
        sessionStorage.setItem("selectedMaterial", JSON.stringify(result));
        console.log("selectedMaterial roomTypes format preserved:", result);
        return result;
      }
      
      if (typeof parsed === "object" && !Array.isArray(parsed)) {
        const roomTypes = Object.entries(parsed)
          .filter(([roomName]) => roomName && typeof roomName === 'string' && roomName.trim())
          .map(([roomName, roomData]) => ({
            roomType: roomName,
            materials: Array.isArray(roomData?.materials) ? roomData.materials : []
          }));
        
        // Ensure at least one valid room type exists
        if (roomTypes.length === 0) {
          roomTypes.push({ roomType: defaultRoom, materials: [] });
        }
        
        const result = { roomTypes };
        sessionStorage.setItem("selectedMaterial", JSON.stringify(result));
        console.log("selectedMaterial converted to roomTypes format:", result);
        return result;
      }
      
      // Default state if format is unknown
      const defaultState = { 
        roomTypes: [{ roomType: defaultRoom, materials: [] }] 
      };
      sessionStorage.setItem("selectedMaterial", JSON.stringify(defaultState));
      console.warn("selectedMaterial unknown format, resetting:", parsed);
      return defaultState;
      
    } catch (error) {
      console.error("selectedMaterial parse error:", error);
      const defaultState = { 
        roomTypes: [{ roomType: "Qonaq otağı", materials: [] }] 
      };
      sessionStorage.setItem("selectedMaterial", JSON.stringify(defaultState));
      return defaultState;
    }
  });

  // Add a new state to track selected categories per room
  const [selectedCategories, setSelectedCategories] = useState({});

  // Update useEffect to initialize selectedCategories
  useEffect(() => {
    // Initialize the selected categories map based on existing materials
    if (selectedMaterial && selectedMaterial.roomTypes) {
      const categoriesMap = {};
      
      selectedMaterial.roomTypes.forEach(roomType => {
        if (!categoriesMap[roomType.roomType]) {
          categoriesMap[roomType.roomType] = {};
        }
        
        if (roomType.materials && roomType.materials.length > 0) {
          roomType.materials.forEach(material => {
            // Skip door and window materials
            if (material.materialId === 'door-material' || material.materialId === 'window-material') {
              return;
            }
            
            // Get the category ID from either categoryId property or categories array
            let categoryId = material.categoryId;
            
            // If no direct categoryId, try to get from categories array
            if (!categoryId && material.categories && material.categories.length > 0) {
              const category = material.categories[0];
              if (typeof category === 'string') {
                categoryId = category;
              } else if (category && (category.id || category._id)) {
                categoryId = category.id || category._id;
              }
            }
            
            if (categoryId) {
              // Store material.id or material.materialId as the selected material for this category
              const materialId = material.id || material.materialId || material._id;
              if (materialId) {
                categoriesMap[roomType.roomType][categoryId] = materialId;
                console.log(`Initialized ${roomType.roomType} category ${categoryId} with material ${materialId}`);
              }
            }
          });
        }
      });
      
      setSelectedCategories(categoriesMap);
      console.log("Initialized selected categories map:", categoriesMap);
    }
  }, [selectedMaterial]);

  // Utility functions for consistent material handling
  const generateMaterialId = () => `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

  const generateTempId = () => `temp-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

  const createStandardMaterialObject = (materialItem, roomId, options = {}) => {
    return {
      id: roomId || generateMaterialId(),
      materialId: materialItem.id,
      type: "standard",
      materialName: getDisplayName(materialItem),
      name: materialItem.name,
      price: options.price !== undefined ? 
        options.price : 
        calculateMaterialPrice(materialItem, selectedRepairTariff),
      servicePrice: materialItem.servicePrice || 0,
      area: options.area !== undefined ? options.area : 1,
      count: options.count || 1,
      roomId: roomId,
      currency: materialItem.currency || "AZN",
      dependentMaterials: options.dependentMaterials || [],
      // IMPORTANT: Preserve usagePerSquareMeter for backend calculations
      usagePerSquareMeter: materialItem.usagePerSquareMeter || 1,
      // Preserve image data for UI rendering
      image: materialItem.image || null,
      imageOnRoom: materialItem.imageOnRoom || null,
      // Preserve category information
      categories: materialItem.categories || [],
      categoryId: options.categoryId || (materialItem.categories?.[0]?.id || null)
    };
  };
  
  const createCustomMaterialObject = (type, roomId, options = {}) => {
    return {
      id: generateMaterialId(type),
      materialId: `${type}-material`,
      type: type,
      name: options.name || (type === "door" ? "Kapı" : "Pəncərə"),
      price: parseFloat(options.price || 0),
      servicePrice: parseFloat(options.servicePrice || 0),
      count: options.count !== undefined ? options.count : 1,
      roomId: roomId,
      currency: options.currency || "AZN"
    };
  };
  
  const getUserInfo = () => {
    const userInfo = {
      userId: null,
      userName: null
    };
    
    try {
      // Try to get from user object first
      if (localStorage.getItem("user")) {
        const userData = JSON.parse(localStorage.getItem("user"));
        if (userData) {
          userInfo.userId = userData._id;
          userInfo.userName = userData.name;
          if (userData.surname) userInfo.userName += ` ${userData.surname}`;
        }
      }
      
      // Fallback to userData
      if (!userInfo.userId && localStorage.getItem("userData")) {
        const userData = JSON.parse(localStorage.getItem("userData"));
        if (userData) {
          userInfo.userId = userData.userId || userData._id;
          userInfo.userName = userData.userName || userData.name;
        }
      }
      
      // Check if logged in but ID unknown
      if (!userInfo.userId && localStorage.getItem("token")) {
        userInfo.userId = "logged-in-user";
        if (!userInfo.userName) userInfo.userName = "Logged In User";
      }
    } catch (error) {
      console.error("Error getting user info:", error);
    }
    
    return userInfo;
  };
  
  const calculateMaterialPrice = (material, tariff) => {
    if (!material || !tariff) return 0;
    
    // Get tariff name from the object
    const tariffName = tariff.name?.text?.toLowerCase() || '';
    
    // Match based on tariff name instead of hardcoded IDs
    if (tariffName.includes('ekonom')) {
      return material.lowPrice || material.price || 0;
    } 
    else if (tariffName.includes('yüksək') || tariffName.includes('yuksek')) {
      return material.highPrice || material.price || 0;
    } 
    else if (tariffName.includes('orta')) {
      return material.midPrice || material.price || 0;
    }
    // Default to mid price if tariff not recognized
    else {
      console.warn("Unknown tariff name:", tariffName);
      return material.midPrice || material.price || 0;
    }
  };

  // Define fetchMaterials before using it in useEffect
  const fetchMaterials = useCallback((categoryId, repairStyleId) => {
    setLoading(true);
    
    // Login kontrolünü bypass etmek için flag'leri ayarla
    localStorage.setItem('skipLoginCheck', 'true');
    localStorage.setItem('bypassAuth', 'true');
    localStorage.setItem('noAuthRequired', 'true');
    sessionStorage.setItem('skipLoginCheck', 'true');
    sessionStorage.setItem('bypassAuth', 'true');
    sessionStorage.setItem('noAuthRequired', 'true');
    
    const selectedRepairTariff = JSON.parse(
      sessionStorage.getItem("selectedRepairTariff")
    );
    const repairTariffId = selectedRepairTariff?.id;
    
    console.log(`Malzemeleri getiriliyor - Kategori: ${categoryId}, Tamir Stili: ${repairStyleId}, Tamir Tarifi: ${repairTariffId}`);
    
    // Fix the endpoint format - remove the duplicate e-prorab prefix
    let endpoint = `materials/filter?categoryId=${categoryId}&repairStyleId=${repairStyleId}`;
    
    // Uncomment this if needed later, but for now we'll omit the tariff ID since it returns empty results
    // if (repairTariffId) {
    //   endpoint += `&repairTariffId=${repairTariffId}`;
    // }
    
    console.log("API endpoint:", getApiEndpoint(endpoint));
    
    axiosWithAuth()
      .get(getApiEndpoint(endpoint))
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          console.log(`${response.data.length} malzeme bulundu`);
          
          // Process each material to ensure it has the proper image and category structure
          const processedMaterials = response.data.map(item => {
            // Log the original image structure
            console.log(`Original material ${item.id || item._id} image structure:`, {
              image: item.image,
              imageOnRoom: item.imageOnRoom
            });
            
            // Ensure categories is an array with proper structure
            if (!item.categories || !Array.isArray(item.categories)) {
              // If no categories or not an array, add the current category
              console.log(`Material ${item.id || item._id} has missing or invalid categories, adding current category`);
              item.categories = [{ id: categoryId, _id: categoryId }];
            } else {
              // Make sure each category has an id property
              item.categories = item.categories.map(cat => {
                if (typeof cat === 'string') {
                  return { id: cat, _id: cat };
                }
                if (!cat.id && cat._id) {
                  cat.id = cat._id;
                }
                if (!cat._id && cat.id) {
                  cat._id = cat.id;
                }
                return cat;
              });
              
              // Ensure the current category is included
              const hasCurrentCategory = item.categories.some(cat => 
                (cat.id === categoryId || cat._id === categoryId)
              );
              
              if (!hasCurrentCategory) {
                console.log(`Material ${item.id || item._id} doesn't have the current category, adding it`);
                item.categories.push({ id: categoryId, _id: categoryId });
              }
            }
            
            return item;
          });
          
          console.log("Processed materials with proper structure:", processedMaterials);
          setMaterial(processedMaterials);
        } else {
          console.log("API yanıtı boş veya dizi değil:", response.data);
          toast(t("material.21"));
          setMaterial([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching materials:", error);
        console.log("Hata detayları:", error.response?.data || "Yanıt yok");
        toast(t("material.22"));
        setMaterial([]);
        setLoading(false);
      });
  }, [t, setMaterial, setLoading]);

  // Gerekli seçimlerin kontrolü
  useEffect(() => {
    // Login kontrolünü bypass etmek için flag'leri ayarla
    localStorage.setItem('skipLoginCheck', 'true');
    localStorage.setItem('bypassAuth', 'true');
    localStorage.setItem('noAuthRequired', 'true');
    sessionStorage.setItem('skipLoginCheck', 'true');
    sessionStorage.setItem('bypassAuth', 'true');
    sessionStorage.setItem('noAuthRequired', 'true');
    
    const selectedRepairStyle = JSON.parse(
      sessionStorage.getItem("selectedRepairStyle")
    );
    
    const selectedRepairTariff = JSON.parse(
      sessionStorage.getItem("selectedRepairTariff")
    );
    
    let timeoutId;
    
    // Repair style kontrolü
    if (!selectedRepairStyle || !selectedRepairStyle.id) {
      console.error("Repair style seçilmemiş!");
      toast(t("material.18"));
      timeoutId = setTimeout(() => {
        navigate("/");
      }, 1500);
      return () => clearTimeout(timeoutId);
    }
    
    // Repair tariff kontrolü
    if (!selectedRepairTariff || !selectedRepairTariff.id) {
      console.error("Repair tariff seçilmemiş!");
      toast(t("material.25") || "Lütfen önce tamir tarifesi seçin");
      timeoutId = setTimeout(() => {
        navigate("/");
      }, 1500);
      return () => clearTimeout(timeoutId);
    }
    
    console.log("Tüm gerekli seçimler yapılmış:", {
      repairStyle: selectedRepairStyle.id,
      repairTariff: selectedRepairTariff.id
    });
    
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [navigate, t]);

  // Odaları session storage'dan alma ve geçerli odaları kontrol etme
  useEffect(() => {
    // roomValues session storage'dan al
    const roomValues = JSON.parse(sessionStorage.getItem("roomValues")) || [];

    // Mevcut seçili odayı kontrol et
    const currentRoom = roomValues.find(room => room.name === selectedRoom);
    
    // Eğer seçili oda artık roomValues'da yoksa, ilk odayı seç
    if (!currentRoom && roomValues.length > 0) {
      setSelectedRoom(roomValues[0].name);
      console.log(`Seçili oda bulunamadı, ilk oda seçildi: ${roomValues[0].name}`);
    }
    
    // Repair style kontrolü
    const repairStyle = JSON.parse(sessionStorage.getItem("selectedRepairStyle"));
    if (!repairStyle || !repairStyle.id) {
      console.log("Repair style bulunamadı, ana sayfaya yönlendiriliyor...");
      toast(t("material.18"));
      setTimeout(() => {
        navigate("/");
      }, 2000);
    }
  }, [selectedRoom, navigate, t]);

  // Material session storage'ı ile sync et
  useEffect(() => {
    // Eğer selectedMaterial bir array içermiyorsa, standardize et
    let standardizedMaterials;
    
    if (selectedMaterial.roomTypes) {
      // Eğer zaten roomTypes formatındaysa, direkt kullan
      standardizedMaterials = selectedMaterial;
    } else {
      // Yeni format (oda adları key olarak kullanılmış) ise, roomTypes dizisine dönüştür
      standardizedMaterials = {
        roomTypes: Object.entries(selectedMaterial).map(([roomName, roomData]) => ({
          roomType: roomName,
          materials: roomData.materials || []
        }))
      };
    }
    
    // selectedMaterial state'ini session storage'a kaydet
    sessionStorage.setItem("selectedMaterial", JSON.stringify(standardizedMaterials));
    console.log("selectedMaterial session storage'a kaydedildi:", standardizedMaterials);
  }, [selectedMaterial]);

  useEffect(() => {
    // Login kontrolünü bypass etmek için flag'leri ayarla
    localStorage.setItem('skipLoginCheck', 'true');
    localStorage.setItem('bypassAuth', 'true');
    localStorage.setItem('noAuthRequired', 'true');
    sessionStorage.setItem('skipLoginCheck', 'true');
    sessionStorage.setItem('bypassAuth', 'true');
    sessionStorage.setItem('noAuthRequired', 'true');
    
    console.log("Materyal kategorileri yükleniyor...");
    axiosWithAuth()
      .get(getApiEndpoint("material-categories"))
      .then((response) => {
        console.log("Material kategorileri:", response.data);
        
        if (Array.isArray(response.data) && response.data.length > 0) {
          setMaterialCategory(response.data);
          console.log(`${response.data.length} materyal kategorisi yüklendi`);

          // Create category to room part mapping
          const mapping = createCategoryMapping(response.data);
          setCategoryRoomMapping(mapping);
          console.log("Category room mapping created:", mapping);

          const selectedRepairStyle = JSON.parse(
            sessionStorage.getItem("selectedRepairStyle")
          );
          const repairStyleId = selectedRepairStyle?.id;
          console.log("Seçilen tamir stili:", selectedRepairStyle);

          if (repairStyleId && response.data?.[0]?.id) {
            console.log(`İlk kategori (${response.data[0].id}) için malzemeleri yüklüyorum`);
            setLoading(true);
            fetchMaterials(response.data[0].id, repairStyleId);
          } else {
            console.log("Tamir stili veya kategori ID'si bulunamadı, malzemeler yüklenemedi");
            if (!repairStyleId) {
              toast(t("material.18"));
              const timeoutId = setTimeout(() => {
                navigate("/");
              }, 2000);
              return () => clearTimeout(timeoutId);
            }
          }
        } else {
          console.log("Hiç materyal kategorisi bulunamadı");
          toast(t("material.23"));
          setMaterialCategory([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching material categories:", error);
        console.log("Kategori yükleme hatası detayları:", error.response?.data || "Yanıt yok");
        toast(t("material.24"));
        setMaterialCategory([]);
      });
  }, [navigate, t, fetchMaterials, setLoading, setMaterialCategory]);

  // Fetch public settings
  useEffect(() => {
    console.log("Public settings yükleniyor...");
    getPublicSettings()
      .then((response) => {
        console.log("Public settings received:", response);
        // Store the data object which contains all the settings
        setPublicSettings(response.data || {});
      })
      .catch((error) => {
        console.error("Error fetching public settings:", error);
        console.log("Settings yükleme hatası detayları:", error.response?.data || "Yanıt yok");
      });
  }, [setPublicSettings]);

  useEffect(() => {
    if (activeSection && !hasLoadedOnce) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setHasLoadedOnce(true);
      }, 5000);
    }
  }, [activeSection, hasLoadedOnce]);

  // Handle button click for category selection
  const handleSectionClick = (categoryId) => {
    if (!selectedRoom) {
      toast(t("material.19"));
      return;
    }
    
    // Login kontrolünü bypass etmek için flag'leri ayarla
    localStorage.setItem('skipLoginCheck', 'true');
    localStorage.setItem('bypassAuth', 'true');
    localStorage.setItem('noAuthRequired', 'true');
    sessionStorage.setItem('skipLoginCheck', 'true');
    sessionStorage.setItem('bypassAuth', 'true');
    sessionStorage.setItem('noAuthRequired', 'true');
    
    const selectedRepairStyle = JSON.parse(
      sessionStorage.getItem("selectedRepairStyle")
    );
    const repairStyleId = selectedRepairStyle?.id;

    const selectedRepairTariff = JSON.parse(
      sessionStorage.getItem("selectedRepairTariff")
    );
    const repairTariffId = selectedRepairTariff?.id;

    if (!repairStyleId) {
      toast(t("material.18"));
      const timeoutId = setTimeout(() => {
        navigate("/");
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
    
    if (!repairTariffId) {
      toast(t("material.25") || "Lütfen önce tamir tarifesi seçin");
      const timeoutId = setTimeout(() => {
        navigate("/");
      }, 2000);
      return () => clearTimeout(timeoutId);
    }

    // Her şey tamam, malzemeleri getir
    try {
      console.log(`Fetching materials for category ${categoryId} with repair style ${repairStyleId}`);
      fetchMaterials(categoryId, repairStyleId);
      setActiveSection(categoryId === activeSection ? null : categoryId);

      // Safari için height hesaplamasını düzenleme
      requestAnimationFrame(() => {
        const dropdownHeight = Math.max(300, window.innerHeight * 0.3);
        document.documentElement.style.setProperty(
          "--dropdown-height",
          `${dropdownHeight}px`
        );
      });
    } catch (error) {
      console.error("Error in handleSectionClick:", error);
      toast.error("Error loading materials. Please try again.");
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveSection(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRoomChange = (newRoom) => {
    console.log("Room changed:", newRoom);
    const roomName = typeof newRoom.name === 'object' ? newRoom.name.text : newRoom.name;
    setSelectedRoom(roomName);
    
    // Reset room visuals to default when changing rooms
    setCeilingImage(DefaultCeiling);
    setWallImage(DefaultWall);
    setFloorImage(DefaultFloor);
    console.log("Reset room visuals to default for new room:", roomName);
    
    // Get existing selectedMaterial from session storage
    const existingMaterial = JSON.parse(sessionStorage.getItem('selectedMaterial') || '{"roomTypes":[]}');
    
    // Check if this room type already exists
    const roomTypeExists = existingMaterial.roomTypes.some(rt => rt.roomType === roomName);
    
    if (!roomTypeExists) {
      // Add new room type with empty materials array
      existingMaterial.roomTypes.push({
        roomType: roomName,
        materials: []
      });
      
      // Save back to session storage
      sessionStorage.setItem('selectedMaterial', JSON.stringify(existingMaterial));
      setSelectedMaterial(existingMaterial);
      console.log("Updated selectedMaterial in storage:", existingMaterial);
    }
  };

  // Update handleMaterialSelect to properly store image data
  const handleMaterialSelect = async (materialItem) => {
    if (!selectedRoom) {
      toast.error(t("material.selectRoomFirst"));
      return;
    }

    try {
      setLoading(true);
      
      // Login kontrolünü bypass etmek için flag'leri ayarla
      localStorage.setItem('skipLoginCheck', 'true');
      localStorage.setItem('bypassAuth', 'true');
      localStorage.setItem('noAuthRequired', 'true');
      sessionStorage.setItem('skipLoginCheck', 'true');
      sessionStorage.setItem('bypassAuth', 'true');
      sessionStorage.setItem('noAuthRequired', 'true');
      
      // Get material ID - make sure we handle both formats
      const materialId = materialItem.id || materialItem._id;
      if (!materialId) {
        console.error("Material has no ID:", materialItem);
        toast.error(t("material.errorSavingMaterial"));
        setLoading(false);
        return;
      }
      
      // Get category information
      let categoryId = null;
      if (materialItem.categories && materialItem.categories.length > 0) {
        const category = materialItem.categories[0];
        if (typeof category === 'string') {
          categoryId = category;
        } else if (category && (category.id || category._id)) {
          categoryId = category.id || category._id;
        }
      }
      
      if (!categoryId) {
        console.error("Material has no category information:", materialItem);
        toast.error(t("material.errorSavingMaterial"));
        setLoading(false);
        return;
      }
      
      console.log(`Processing material selection: ID=${materialId}, Category=${categoryId}, Room=${selectedRoom}`);
      
      // Check if this material is already selected in this category
      const selectedMaterialId = selectedCategories[selectedRoom]?.[categoryId];
      const isAlreadySelected = selectedMaterialId === materialId;
      
      console.log(`Material ${materialId} in category ${categoryId} - Already selected: ${isAlreadySelected}`);
      
      // Get current state from session storage
      const currentMaterial = JSON.parse(sessionStorage.getItem('selectedMaterial') || '{"roomTypes":[]}');
      
      // Find the room type index
      let roomTypeIndex = currentMaterial.roomTypes.findIndex(rt => rt.roomType === selectedRoom);
      
      // If room type doesn't exist, create it
      if (roomTypeIndex === -1) {
        currentMaterial.roomTypes.push({
          roomType: selectedRoom,
          materials: []
        });
        roomTypeIndex = currentMaterial.roomTypes.length - 1;
      }
      
      // If the room has no materials array, initialize it
      if (!currentMaterial.roomTypes[roomTypeIndex].materials) {
        currentMaterial.roomTypes[roomTypeIndex].materials = [];
      }
      
      // Look for existing material in this category
      const existingIndex = currentMaterial.roomTypes[roomTypeIndex].materials.findIndex(m => 
        (m.categoryId === categoryId) || 
        (m.categories && m.categories.some(c => 
          (typeof c === 'string' && c === categoryId) || 
          (c.id === categoryId) || 
          (c._id === categoryId)
        ))
      );
      
      // If it's the same material already selected, remove it (toggle behavior)
      if (isAlreadySelected && existingIndex !== -1) {
        console.log(`Removing selected material ${materialId} from category ${categoryId}`);
        
        // Remove the material from this category
        currentMaterial.roomTypes[roomTypeIndex].materials.splice(existingIndex, 1);
        
        // Update selected categories map
        setSelectedCategories(prev => {
          const updated = {...prev};
          if (updated[selectedRoom] && updated[selectedRoom][categoryId]) {
            delete updated[selectedRoom][categoryId];
          }
          return updated;
        });
        
        // Save to both session storage and state
        sessionStorage.setItem('selectedMaterial', JSON.stringify(currentMaterial));
        setSelectedMaterial(currentMaterial);
        
        toast.success(t("material.materialRemoved"));
        
        // Close the dropdown after selection
        setActiveSection(null);
        
        setLoading(false);
        return;
      }
      
      // If there's a different material in this category, replace it
      if (existingIndex !== -1) {
        console.log(`Replacing material in category ${categoryId}`);
        currentMaterial.roomTypes[roomTypeIndex].materials.splice(existingIndex, 1);
      }
      
      // Update the room visuals based on the material category
      console.log("About to update room visuals for material:", {
        materialId: materialId,
        materialName: getDisplayName(materialItem),
        categories: materialItem.categories,
        hasImage: !!materialItem.image,
        hasImageOnRoom: !!materialItem.imageOnRoom
      });
      updateRoomVisuals(materialItem);
      
      // Process dependent materials if any
      let dependentMaterials = [];
      
      // First, let's check for dependent materials from the API
      if (materialItem.dependentMaterials && materialItem.dependentMaterials.length > 0) {
        console.log(`Material ${materialId} has ${materialItem.dependentMaterials.length} dependent materials`);
        
        try {
          // Fetch each dependent material
          const depPromises = materialItem.dependentMaterials.map(depId => 
            axiosWithAuth().get(getApiEndpoint(`materials/${depId}`))
          );
          
          const results = await Promise.allSettled(depPromises);
          
          const fetchedDependents = results
            .filter(result => result.status === 'fulfilled' && result.value?.data)
            .map(result => {
              const depMaterial = result.value.data;
              return {
                materialId: depMaterial._id || depMaterial.id,
                name: depMaterial.name,
                price: calculateMaterialPrice(depMaterial, selectedRepairTariff) || depMaterial.price || 0,
                servicePrice: depMaterial.servicePrice || 0,
                count: 1,
                area: 1,
                currency: depMaterial.currency || 'AZN',
                isDependentMaterial: true,
                parentMaterialId: materialId,
                // Very important: preserve isDefault flag
                isDefault: depMaterial.isDefault === true,
                // IMPORTANT: Preserve usagePerSquareMeter for backend calculations
                usagePerSquareMeter: depMaterial.usagePerSquareMeter || 1,
                // Preserve image information
                image: depMaterial.image,
                imageOnRoom: depMaterial.imageOnRoom
              };
            });
            
          console.log(`Successfully fetched ${fetchedDependents.length} dependent materials`);
          
          // Add dependent materials to our array
          dependentMaterials = [...dependentMaterials, ...fetchedDependents];
        } catch (error) {
          console.error('Error fetching dependent materials:', error);
        }
      }

      // Second, let's get default dependent materials from the API for ALL materials in the database
      // regardless of whether they were selected by the user
      try {
        console.log('Fetching all default dependent materials...');
        const { data } = await axiosWithAuth().get(getApiEndpoint('dependent-materials'));
        
        if (data && Array.isArray(data)) {
          // Filter for default dependent materials only
          const defaultDependents = data.filter(dep => dep.isDefault === true);
          console.log(`Found ${defaultDependents.length} default dependent materials in total`);
          
          if (defaultDependents.length > 0) {
            // Map them to our format
            const formattedDefaultDependents = defaultDependents.map(dep => ({
              materialId: dep.id || dep._id,
              name: dep.name,
              price: calculateMaterialPrice(dep, selectedRepairTariff) || dep.price || 0,
              servicePrice: dep.servicePrice || 0,
              count: 1,
              area: 1,
              currency: dep.currency || 'AZN',
              isDependentMaterial: true,
              parentMaterialId: 'global-default', // Mark it as a global default
              isDefault: true, // Explicitly mark as default
              // IMPORTANT: Preserve usagePerSquareMeter for backend calculations
              usagePerSquareMeter: dep.usagePerSquareMeter || 1,
              // Preserve image information
              image: dep.image,
              imageOnRoom: dep.imageOnRoom
            }));
            
            // Add these global defaults to our dependent materials array
            dependentMaterials = [...dependentMaterials, ...formattedDefaultDependents];
            console.log(`Added ${formattedDefaultDependents.length} global default dependent materials`);
          }
        }
      } catch (error) {
        console.error('Error fetching global default dependent materials:', error);
      }

      // Process linked dependent materials if any
      if (materialItem.linkedDependentMaterials && Array.isArray(materialItem.linkedDependentMaterials) && materialItem.linkedDependentMaterials.length > 0) {
        for (const link of materialItem.linkedDependentMaterials) {
          const depMaterial = link.material;
          const quantity = parseFloat(link.quantity || 1);
          const depPrice = parseFloat(depMaterial.price || 0);
          const depServicePrice = parseFloat(depMaterial.servicePrice || 0);
          
          const depMaterialCost = depPrice * quantity;
          const depServiceCost = depServicePrice * quantity;
          
          dependentMaterials.push({
            materialId: depMaterial._id || depMaterial.id,
            name: depMaterial.name,
            price: depMaterialCost,
            servicePrice: depServiceCost,
            count: quantity,
            area: 1,
            currency: depMaterial.currency || 'AZN',
            isDependentMaterial: true,
            parentMaterialId: materialId,
            // IMPORTANT: Preserve usagePerSquareMeter for backend calculations
            usagePerSquareMeter: depMaterial.usagePerSquareMeter || 1,
            // Preserve image information
            image: depMaterial.image,
            imageOnRoom: depMaterial.imageOnRoom
          });
        }
      }

      // Make sure we store the complete original image objects with all properties
      console.log(`Processing material selection with path info:`, {
        imagePath: materialItem.image?.path,
        imageOnRoomPath: materialItem.imageOnRoom?.path
      });

      // Create a deep copy of image data to preserve all properties
      const imageData = {};

      // Preserve the entire image object with path and _id
      if (materialItem.image) {
        // Use deep copy to ensure we don't lose any properties
        imageData.image = JSON.parse(JSON.stringify(materialItem.image));
        console.log(`Preserved complete image object for material ${materialId}:`, {
          hasPath: !!imageData.image.path,
          path: imageData.image.path,
          imageId: imageData.image._id
        });
      }

      // Preserve the entire imageOnRoom object with path and _id
      if (materialItem.imageOnRoom) {
        // Use deep copy for imageOnRoom too
        imageData.imageOnRoom = JSON.parse(JSON.stringify(materialItem.imageOnRoom));
        console.log(`Preserved complete imageOnRoom object for material ${materialId}:`, {
          hasPath: !!imageData.imageOnRoom.path,
          path: imageData.imageOnRoom.path,
          imageId: imageData.imageOnRoom._id
        });
      }

      // Create and add the new material with preserved image data
      const newMaterialId = generateMaterialId();
      const newMaterial = {
        id: newMaterialId,
        materialId: materialId,
        type: "standard",
        materialName: getDisplayName(materialItem),
        name: materialItem.name,
        price: calculateMaterialPrice(materialItem, selectedRepairTariff),
        servicePrice: materialItem.servicePrice || 0,
        area: 1,
        count: 1,
        roomId: newMaterialId,
        currency: materialItem.currency || "AZN",
        dependentMaterials: dependentMaterials || [],
        // IMPORTANT: Preserve usagePerSquareMeter for backend calculations
        usagePerSquareMeter: materialItem.usagePerSquareMeter || 1,
        // Store complete image objects with all properties including _id
        image: imageData.image || null,
        imageOnRoom: imageData.imageOnRoom || null,
        // Preserve category information
        categories: materialItem.categories || [],
        categoryId: categoryId
      };
      
      // Add the material to the room
      currentMaterial.roomTypes[roomTypeIndex].materials.push(newMaterial);
      
      // Update selected categories map
      setSelectedCategories(prev => {
        const updated = {...prev};
        if (!updated[selectedRoom]) updated[selectedRoom] = {};
        updated[selectedRoom][categoryId] = materialId;
        return updated;
      });
      
      console.log(`Added new material ${newMaterialId} to room ${selectedRoom} in category ${categoryId}:`, newMaterial);
      
      // Save to both session storage and state
      sessionStorage.setItem('selectedMaterial', JSON.stringify(currentMaterial));
      setSelectedMaterial(currentMaterial);
      
      toast.success(t("material.materialAdded"));
      
      // Close the dropdown after selection
      setActiveSection(null);
      
    } catch (error) {
      console.error('Error saving material selection:', error);
      toast.error(t("material.errorSavingMaterial"));
    } finally {
      setLoading(false);
    }
  };

  // Add new function to update room visuals based on selected material
  const updateRoomVisuals = (material) => {
    try {
      if (!material || !material.categories) return;
      
      // Get the category information
      const category = material.categories[0];
      if (!category) return;
      
      // Get material image URL - first try imageOnRoom which is meant for visualization
      let imageUrl = null;
      
      if (material.imageOnRoom) {
        imageUrl = getImageUrl(material.imageOnRoom);
        console.log(`Using imageOnRoom for visualization: ${imageUrl}`);
      }
      
      // If no imageOnRoom, try the regular image
      if (!imageUrl && material.image) {
        imageUrl = getImageUrl(material.image);
        console.log(`Using regular image for visualization: ${imageUrl}`);
      }
      
      // If still no image, return
      if (!imageUrl) {
        console.log('No image available for this material', material.id);
        return;
      }
      
      console.log(`Updating room visuals with image URL: ${imageUrl}`);
      
      // Get category ID for mapping lookup
      const categoryId = category.id || category._id;
      
      // Check if we have a mapping for this category
      const categoryMapping = categoryRoomMapping[categoryId];
      
      if (categoryMapping) {
        const roomPart = categoryMapping.roomPart;
        console.log(`Found mapping for category ${categoryId} (${categoryMapping.categoryName}) -> ${roomPart}`);
        
        switch (roomPart) {
          case 'ceiling':
        console.log('Setting ceiling image to:', imageUrl);
        setCeilingImage(imageUrl);
            break;
          case 'wall':
        console.log('Setting wall image to:', imageUrl);
        setWallImage(imageUrl);
            break;
          case 'floor':
        console.log('Setting floor image to:', imageUrl);
        setFloorImage(imageUrl);
            break;
          default:
            console.log('Unknown room part:', roomPart);
        }
      } else {
        console.log(`No mapping found for category ${categoryId}. Available mappings:`, Object.keys(categoryRoomMapping));
        
        // Fallback to name-based detection as backup
        const categoryName = category.name?.text || category.name?.az || category.name?.en || category.name || '';
        const roomPart = determineRoomPartFromCategory(categoryName);
        
        if (roomPart) {
          console.log(`Fallback: Determined room part "${roomPart}" from category name "${categoryName}"`);
          
          switch (roomPart) {
            case 'ceiling':
              console.log('Setting ceiling image (fallback) to:', imageUrl);
              setCeilingImage(imageUrl);
              break;
            case 'wall':
              console.log('Setting wall image (fallback) to:', imageUrl);
              setWallImage(imageUrl);
              break;
            case 'floor':
              console.log('Setting floor image (fallback) to:', imageUrl);
              setFloorImage(imageUrl);
              break;
          }
        } else {
          console.log('Could not determine room part for category:', {
            categoryId,
            categoryName,
            fullCategory: category
          });
        }
      }
    } catch (error) {
      console.error('Error updating room visuals:', error);
    }
  };

  const sendRepairStyleID = 
    JSON.parse(sessionStorage.getItem("selectedRepairStyle"))?.id || "";
  const sendPropertyTypeID = 
    JSON.parse(sessionStorage.getItem("selectedPropertyType"))?.id || "";
  const sendRepairTariffID = 
    JSON.parse(sessionStorage.getItem("selectedRepairTariff"))?.id || "";
  const sendPropertyStatusID = 
    JSON.parse(sessionStorage.getItem("selectedPropertyStatuses"))?.id || "";
  const sendHomeData = JSON.parse(sessionStorage.getItem("homeData"));
  const sendRoom = JSON.parse(sessionStorage.getItem("roomValues"));

  const data = {
    repairStyle: sendRepairStyleID,
    repairTariff: sendRepairTariffID,
    property: {
      propertyType: sendPropertyTypeID,
      propertyStatus: sendPropertyStatusID,
      area: parseInt(sendHomeData?.areaHouse) || 0,
      height: parseInt(sendHomeData?.heightWall) || 0,
      roomCount: parseInt(sendHomeData?.roomCount) || 0,
      doorCount: parseInt(sendHomeData?.roomDoorCount) || 0,
      windowCount: parseInt(sendHomeData?.windowCount) || 0,
      rooms: sendRoom.map((room) => {
        const roomMaterials = selectedMaterial[room.name]?.materials || [];
        return {
          roomType: room.originalId,
          width: parseInt(room.width) || 0,
          length: parseInt(room.length) || 0,
          area: parseInt(room.area) || 0,
          height: parseInt(room.height) || 0,
          roomComponents: roomMaterials.map((material) => ({
            materialCategory: material.categoryId,
            material: material.id,
            status: true,
          })),
          status: true,
        };
      }),
      status: true,
    },
    status: true,
  };

  // Malzemelerin fiyatlarını ve alanlarını hesapla
  const calculateMaterialCosts = async (materials) => {
    let totalMaterialCost = 0;
    let totalServiceCost = 0;

    const calculateSingleMaterialCost = async (material, area = 1, depth = 0) => {
      let materialCost = 0;
      let serviceCost = 0;

      // Base material costs with usagePerSquareMeter calculation
      const price = parseFloat(material.price || 0);
      const servicePrice = parseFloat(material.servicePrice || 0);
      const quantity = parseFloat(material.quantity || 1);
      const usagePerSquareMeter = parseFloat(material.usagePerSquareMeter || 1);
      
      // Material cost calculation: area * usagePerSquareMeter * price * quantity
      const actualMaterialUsage = area * usagePerSquareMeter;
      materialCost += price * actualMaterialUsage * quantity;
      
      // Service cost calculation: area * servicePrice * quantity (no usagePerSquareMeter for service)
      serviceCost += servicePrice * area * quantity;

      console.log(`Calculating costs for ${material.name?.text || 'Unknown'} at depth ${depth}:`, {
        price,
        servicePrice,
        quantity,
        area,
        usagePerSquareMeter,
        actualMaterialUsage,
        materialCost: `${price} * ${actualMaterialUsage} * ${quantity} = ${materialCost}`,
        serviceCost: `${servicePrice} * ${area} * ${quantity} = ${serviceCost}`,
        materialCost_value: materialCost,
        serviceCost_value: serviceCost
      });

      // Handle traditional dependent materials
      if (material.dependentMaterials && Array.isArray(material.dependentMaterials)) {
        for (const depMaterial of material.dependentMaterials) {
          const { matCost, servCost } = await calculateSingleMaterialCost(depMaterial, area, depth + 1);
          materialCost += matCost;
          serviceCost += servCost;
        }
      }

      // Handle linked dependent materials
      if (material.linkedDependentMaterials && Array.isArray(material.linkedDependentMaterials)) {
        for (const link of material.linkedDependentMaterials) {
          if (!link.material) continue;
          
          const depQuantity = parseFloat(link.quantity || 1);
          const { matCost, servCost } = await calculateSingleMaterialCost(
            link.material,
            1, // Area is 1 for linked materials as quantity handles the multiplication
            depth + 1
          );
          
          // Multiply by the link quantity
          materialCost += matCost * depQuantity;
          serviceCost += servCost * depQuantity;
        }
      }

      return { matCost: materialCost, servCost: serviceCost };
    };

    // Calculate for each material
    for (const material of materials) {
      const area = parseFloat(material.area || 1);
      const { matCost, servCost } = await calculateSingleMaterialCost(material, area);
      totalMaterialCost += matCost;
      totalServiceCost += servCost;
    }

    return {
      materialCost: totalMaterialCost,
      serviceCost: totalServiceCost,
      totalCost: totalMaterialCost + totalServiceCost
    };
  };

  const calculateMaterialSummary = async (selectedMaterialObj, rooms, selectedRepairTariff) => {
    try {
      let totalMaterialCost = 0;
      let totalServiceCost = 0;
      let totalDependentMaterialCost = 0;
      let totalDependentServiceCost = 0;
      let currency = 'AZN';

      // Process each room
      for (const roomData of rooms) {
        let roomMaterialCost = 0;
        let roomServiceCost = 0;
        let roomDependentMaterialCost = 0;
        let roomDependentServiceCost = 0;

        const roomArea = parseFloat(roomData.area || 0);
        console.log(`Processing room with area: ${roomArea}m²`);

        // Calculate costs for all materials in the room
        if (roomData.materials && Array.isArray(roomData.materials)) {
        for (const material of roomData.materials) {
          try {
            // Skip door/window materials as they're handled separately
            if (material.materialId === 'door-material' || material.materialId === 'window-material') {
              continue;
            }

              const costs = await calculateMaterialCosts([material]);
              
              roomMaterialCost += costs.materialCost;
              roomServiceCost += costs.serviceCost;
                
              console.log(`Material costs for ${getDisplayName(material)}:`, costs);

          } catch (error) {
            console.error("Error calculating material cost:", error, material);
          }
        }
        }

        // Update room totals
        roomData.materialCost = roomMaterialCost;
        roomData.serviceCost = roomServiceCost;
        roomData.dependentMaterialCost = roomDependentMaterialCost;
        roomData.dependentServiceCost = roomDependentServiceCost;
        roomData.totalCost = roomMaterialCost + roomServiceCost + roomDependentMaterialCost + roomDependentServiceCost;

        // Update overall totals
        totalMaterialCost += roomMaterialCost;
        totalServiceCost += roomServiceCost;
        totalDependentMaterialCost += roomDependentMaterialCost;
        totalDependentServiceCost += roomDependentServiceCost;
      }

      // Process fixtures if they exist
      if (selectedMaterialObj.fixtures) {
        const { doors, windows } = selectedMaterialObj.fixtures;
        
        if (doors?.materials) {
          const doorCosts = await calculateMaterialCosts(doors.materials);
          totalMaterialCost += doorCosts.materialCost;
          totalServiceCost += doorCosts.serviceCost;
        }
        
        if (windows?.materials) {
          const windowCosts = await calculateMaterialCosts(windows.materials);
          totalMaterialCost += windowCosts.materialCost;
          totalServiceCost += windowCosts.serviceCost;
        }
      }

      const generalCost = totalMaterialCost + totalServiceCost + totalDependentMaterialCost + totalDependentServiceCost;
      
      return {
        materialsCost: totalMaterialCost,
        serviceCost: totalServiceCost,
        dependentMaterialCost: totalDependentMaterialCost,
        dependentServiceCost: totalDependentServiceCost,
        generalCost,
        currency
      };
      } catch (error) {
      console.error('Error in calculateMaterialSummary:', error);
      throw error;
      }
    };

  // Hesaplama ve sonuçları saklama
  const postRepairData = async () => {
    try {
      console.log('Executing postRepairData');
      setLoading(true);

      // Check if we have materials selected
      if (!selectedMaterial?.roomTypes?.length) {
        toast.error('Please select at least one material for a room');
            return;
          }
          
      // Get default materials status from localStorage
      let defaultMaterialsStatus = {};
      try {
        const savedStatus = localStorage.getItem('defaultMaterialsStatus');
        if (savedStatus) {
          defaultMaterialsStatus = JSON.parse(savedStatus);
          console.log('Loaded default materials status from localStorage:', defaultMaterialsStatus);
        }
      } catch (error) {
        console.error('Error loading default materials status:', error);
      }
      
      // Get fresh roomValues from sessionStorage to ensure we have the latest data
      const freshRoomValues = JSON.parse(sessionStorage.getItem('roomValues') || '[]');
      console.log('Fresh roomValues from sessionStorage:', freshRoomValues);
      
      // Prepare calculation data with the correct format
      // Make sure materials are properly grouped by room
      const groupedMaterials = {
        roomTypes: selectedMaterial.roomTypes.map(roomType => {
          // Find the room data from freshRoomValues
          const roomData = freshRoomValues.find(room => room.name === roomType.roomType) || {};
          const roomId = roomData.id || generateMaterialId();
          
          // Group materials by room
          return {
            roomType: roomType.roomType,
            roomId: roomId,
            roomArea: roomData.area || 0,
            materials: roomType.materials.map(material => {
              // Make sure each material has roomType property for grouping
              return {
                ...material,
                roomType: roomType.roomType,
                roomId: roomId,
                roomArea: roomData.area || 0,
                // Process dependent materials to also have room information
                dependentMaterials: (material.dependentMaterials || []).map(depMaterial => ({
                  ...depMaterial,
                  roomType: roomType.roomType,
                  roomId: roomId,
                  roomArea: roomData.area || 0,
                  parentMaterialId: material.materialId,
                  parentMaterialName: material.materialName || material.name?.text || material.name?.az || ''
                }))
              };
            })
          };
        })
      };

      console.log('Materials grouped by room:', groupedMaterials);
      
      const calculationData = {
        repairStyle: selectedRepairStyle,
        repairTariff: selectedRepairTariff,
        property: {
          ...sendHomeData,  // Include all sendHomeData
          roomValues: freshRoomValues,  // Add room details that backend expects
          totalArea: parseFloat(sendHomeData?.areaHouse) || 0,
          roomHeight: parseFloat(sendHomeData?.heightWall) || 0,
          totalDoorCount: parseInt(sendHomeData?.roomDoorCount) || 0,
          totalWindowCount: parseInt(sendHomeData?.windowCount) || 0
        },
        materials: groupedMaterials,
        defaultMaterialsStatus
      };
      
      console.log('Calculation data being sent:', calculationData);
      console.log('Room values:', freshRoomValues);

      // Call backend to calculate breakdown
      const breakdownResult = await calculateRepairBreakdown(calculationData);
      console.log('Breakdown calculation result:', breakdownResult);

      if (!breakdownResult || !breakdownResult.breakdown) {
        throw new Error('Failed to calculate breakdown');
      }

      // Generate a unique ID for this repair
      const repairId = `temp-${Date.now()}`;

      // Prepare repair data with the calculated breakdown
      const repairData = {
        materials: groupedMaterials,
        costs: breakdownResult.costs,
        repairStyle: selectedRepairStyle,
        repairTariff: selectedRepairTariff,
        homeData: sendHomeData,
        property: {
          totalArea: parseFloat(sendHomeData?.areaHouse) || 0,
          roomHeight: parseFloat(sendHomeData?.heightWall) || 0,
          roomValues: freshRoomValues,
          totalDoorCount: parseInt(sendHomeData?.roomDoorCount) || 0,
          totalWindowCount: parseInt(sendHomeData?.windowCount) || 0
        },
        breakdown: breakdownResult.breakdown,
        user: getUserInfo(),
        defaultMaterialsStatus,
        // Flag to indicate this is a direct navigation, don't prompt for login
        skipLoginCheck: true,
        // Ekstra güvenlik için login kontrolünü bypass etmek için flag'ler
        bypassAuth: true,
        noAuthRequired: true
      };

      // Save to both localStorage and sessionStorage
      localStorage.setItem(repairId, JSON.stringify(repairData));
      sessionStorage.setItem('currentRepairData', JSON.stringify(repairData));
      sessionStorage.setItem('selectedMaterial', JSON.stringify(selectedMaterial));
      
      // Login kontrolünü bypass etmek için flag'leri ayarla
      localStorage.setItem('skipLoginCheck', 'true');
      localStorage.setItem('bypassAuth', 'true');
      localStorage.setItem('noAuthRequired', 'true');
      sessionStorage.setItem('skipLoginCheck', 'true');
      sessionStorage.setItem('bypassAuth', 'true');
      sessionStorage.setItem('noAuthRequired', 'true');
      
      console.log('Saved repair data with auth bypass flags:', repairData);

      // Navigate to repair summary page with the ID
      navigate(`/repair-summary/${repairId}`);
    } catch (error) {
      console.error('Error in postRepairData:', error);
      toast.error('Failed to process repair data');
    } finally {
      setLoading(false);
    }
  };

  // Kapı ekle
  const handleAddDoorMaterial = () => {
    console.log("Adding door material with publicSettings:", publicSettings);
    
    // Get style and tariff names for specific pricing
    const styleNameNormalized = selectedRepairStyle?.name?.az?.toLowerCase().replace(/[^a-z0-9]/g, '-') || 'modern';
    const tariffNameNormalized = selectedRepairTariff?.name?.az?.toLowerCase().replace(/[^a-z0-9]/g, '-') || 'ekonom';
    
    // Create specific door price keys
    const doorPriceKey = `doorPrice-${styleNameNormalized}-${tariffNameNormalized}`;
    const doorServicePriceKey = `doorServicePrice-${styleNameNormalized}-${tariffNameNormalized}`;
    
    // Use optional chaining to safely access values from API
    const doorPrice = publicSettings?.[doorPriceKey] || publicSettings?.doorPrice || 80;
    const doorServicePrice = publicSettings?.[doorServicePriceKey] || publicSettings?.doorServicePrice || 30;
    
    console.log("Door price settings:", {
      doorPrice,
      doorServicePrice,
      fromAPI: !!publicSettings?.[doorPriceKey],
      specificKey: doorPriceKey,
      fallbackUsed: !publicSettings?.[doorPriceKey] && !!publicSettings?.doorPrice,
      publicSettings
    });
    
    try {
      // Get current state
      let currentSelectedMaterial = JSON.parse(
        sessionStorage.getItem("selectedMaterial") || "{}"
      );
      
      // Create room type object if it doesn't exist
      if (!currentSelectedMaterial.roomTypes) {
        currentSelectedMaterial.roomTypes = [];
      }

      // Find the correct room type index
      const roomTypeIndex = currentSelectedMaterial.roomTypes.findIndex(
        (roomType) => roomType.roomType === selectedRoom
      );

      // If the room type exists, add/update door material
      if (roomTypeIndex !== -1) {
        if (!currentSelectedMaterial.roomTypes[roomTypeIndex].materials) {
          currentSelectedMaterial.roomTypes[roomTypeIndex].materials = [];
        }

        // Look for existing door material
        const existingDoorIndex = currentSelectedMaterial.roomTypes[roomTypeIndex].materials.findIndex(
          (material) => material.materialId === "door-material"
        );

        if (existingDoorIndex !== -1) {
          // Update existing door count
          const currentCount = parseInt(currentSelectedMaterial.roomTypes[roomTypeIndex].materials[existingDoorIndex].count || 1);
          currentSelectedMaterial.roomTypes[roomTypeIndex].materials[existingDoorIndex].count = currentCount + 1;
          console.log("Updated door count to:", currentCount + 1);
        } else {
          // Add new door material
          const doorMaterial = {
            id: generateMaterialId(),
            materialId: "door-material",
            materialName: "Qapı",
            name: { az: "Qapı", en: "Door", ru: "Дверь" },
            count: 1,
            price: parseFloat(doorPrice),
            servicePrice: parseFloat(doorServicePrice),
            priceKey: doorPriceKey,
            servicePriceKey: doorServicePriceKey,
            currency: "AZN",
            style: styleNameNormalized,
            tariff: tariffNameNormalized
          };
          currentSelectedMaterial.roomTypes[roomTypeIndex].materials.push(doorMaterial);
          console.log("Added new door material:", doorMaterial);
        }
      } else {
        // Create a new room type with the door material
        const newRoomType = {
          roomType: selectedRoom,
          materials: [
            {
              id: generateMaterialId(),
              materialId: "door-material",
              materialName: "Qapı",
              name: { az: "Qapı", en: "Door", ru: "Дверь" },
              count: 1,
              price: parseFloat(doorPrice),
              servicePrice: parseFloat(doorServicePrice),
              priceKey: doorPriceKey,
              servicePriceKey: doorServicePriceKey,
              currency: "AZN",
              style: styleNameNormalized,
              tariff: tariffNameNormalized
            },
          ],
        };
        currentSelectedMaterial.roomTypes.push(newRoomType);
        console.log("Created new room type with door:", newRoomType);
      }

      // Save to session storage and state
      sessionStorage.setItem("selectedMaterial", JSON.stringify(currentSelectedMaterial));
      setSelectedMaterial(currentSelectedMaterial);
      toast.success("Qapı əlavə edildi");
    } catch (error) {
      console.error("Error adding door material:", error);
      toast.error("Qapı əlavə edilərkən xəta baş verdi");
    }
  };

  // Pəncərə ekle
  const handleAddWindowMaterial = () => {
    console.log("Adding window material with publicSettings:", publicSettings);
    
    // Get style and tariff names for specific pricing
    const styleNameNormalized = selectedRepairStyle?.name?.az?.toLowerCase().replace(/[^a-z0-9]/g, '-') || 'modern';
    const tariffNameNormalized = selectedRepairTariff?.name?.az?.toLowerCase().replace(/[^a-z0-9]/g, '-') || 'ekonom';
    
    // Create specific window price keys
    const windowPriceKey = `windowPrice-${styleNameNormalized}-${tariffNameNormalized}`;
    const windowServicePriceKey = `windowServicePrice-${styleNameNormalized}-${tariffNameNormalized}`;
    
    // Use optional chaining to safely access values from API
    const windowPrice = publicSettings?.[windowPriceKey] || publicSettings?.windowPrice || 60;
    const windowServicePrice = publicSettings?.[windowServicePriceKey] || publicSettings?.windowServicePrice || 20;
    
    console.log("Window price settings:", {
      windowPrice,
      windowServicePrice,
      fromAPI: !!publicSettings?.[windowPriceKey],
      specificKey: windowPriceKey,
      fallbackUsed: !publicSettings?.[windowPriceKey] && !!publicSettings?.windowPrice,
      publicSettings
    });
    
    try {
      // Get current state
      let currentSelectedMaterial = JSON.parse(
        sessionStorage.getItem("selectedMaterial") || "{}"
      );
      
      // Create room type object if it doesn't exist
      if (!currentSelectedMaterial.roomTypes) {
        currentSelectedMaterial.roomTypes = [];
      }

      // Find the correct room type index
      const roomTypeIndex = currentSelectedMaterial.roomTypes.findIndex(
        (roomType) => roomType.roomType === selectedRoom
      );

      // If the room type exists, add/update window material
      if (roomTypeIndex !== -1) {
        if (!currentSelectedMaterial.roomTypes[roomTypeIndex].materials) {
          currentSelectedMaterial.roomTypes[roomTypeIndex].materials = [];
        }

        // Look for existing window material
        const existingWindowIndex = currentSelectedMaterial.roomTypes[roomTypeIndex].materials.findIndex(
          (material) => material.materialId === "window-material"
        );

        if (existingWindowIndex !== -1) {
          // Update existing window count
          const currentCount = parseInt(currentSelectedMaterial.roomTypes[roomTypeIndex].materials[existingWindowIndex].count || 1);
          currentSelectedMaterial.roomTypes[roomTypeIndex].materials[existingWindowIndex].count = currentCount + 1;
          console.log("Updated window count to:", currentCount + 1);
        } else {
          // Add new window material
          const windowMaterial = {
            id: generateMaterialId(),
            materialId: "window-material",
            materialName: "Pəncərə",
            name: { az: "Pəncərə", en: "Window", ru: "Окно" },
            count: 1,
            price: parseFloat(windowPrice),
            servicePrice: parseFloat(windowServicePrice),
            priceKey: windowPriceKey,
            servicePriceKey: windowServicePriceKey,
            currency: "AZN",
            style: styleNameNormalized,
            tariff: tariffNameNormalized
          };
          currentSelectedMaterial.roomTypes[roomTypeIndex].materials.push(windowMaterial);
          console.log("Added new window material:", windowMaterial);
        }
      } else {
        // Create a new room type with the window material
        const newRoomType = {
          roomType: selectedRoom,
          materials: [
            {
              id: generateMaterialId(),
              materialId: "window-material",
              materialName: "Pəncərə",
              name: { az: "Pəncərə", en: "Window", ru: "Окно" },
              count: 1,
              price: parseFloat(windowPrice),
              servicePrice: parseFloat(windowServicePrice),
              priceKey: windowPriceKey,
              servicePriceKey: windowServicePriceKey,
              currency: "AZN",
              style: styleNameNormalized,
              tariff: tariffNameNormalized
            },
          ],
        };
        currentSelectedMaterial.roomTypes.push(newRoomType);
        console.log("Created new room type with window:", newRoomType);
      }

      // Save to session storage and state
      sessionStorage.setItem("selectedMaterial", JSON.stringify(currentSelectedMaterial));
      setSelectedMaterial(currentSelectedMaterial);
      toast.success("Pəncərə əlavə edildi");
    } catch (error) {
      console.error("Error adding window material:", error);
      toast.error("Pəncərə əlavə edilərkən xəta baş verdi");
    }
  };

  // Helper function to update a specific material
  const updateMaterial = (id, updatedMaterial) => {
    setSelectedMaterial(prevMaterials => {
      // Create a deep copy of the previous materials state
      const newMaterials = structuredClone(prevMaterials);
      
      // Find which room contains the material with the given id
      for (const roomKey in newMaterials) {
        if (newMaterials[roomKey] && newMaterials[roomKey].materials) {
          const materialIndex = newMaterials[roomKey].materials.findIndex(m => m.id === id);
          
          if (materialIndex !== -1) {
            // Update the material in the found room
            newMaterials[roomKey].materials[materialIndex] = {
              ...newMaterials[roomKey].materials[materialIndex],
              ...updatedMaterial
            };
            break;
          }
        }
      }
      
      // Save to sessionStorage
      sessionStorage.setItem("selectedMaterial", JSON.stringify(newMaterials));
      
      return newMaterials;
    });
  };

  // Helper function to check if a material is selected
  const isMaterialSelected = (materialId) => {
    if (!selectedMaterial.roomTypes || !selectedRoom) return false;
    
    const currentRoom = selectedMaterial.roomTypes.find(
      room => room.roomType === selectedRoom
    );
    
    return currentRoom?.materials?.some(mat => mat.materialId === materialId);
  };

  // Helper function to extract name as string - move this outside the renderSelectedMaterials function so it can be reused
  const getDisplayName = (material) => {
    if (!material) return '';
    
    // For door and window materials which have name in a specific format
    if (material.materialName) return material.materialName;
    
    // Handle when name is a string
    if (typeof material.name === 'string') return material.name;
    
    // Handle when name is an object with the structure: { az: "...", en: "...", ru: "..." }
    if (material.name && typeof material.name === 'object') {
      // Try to get language-specific name
      if (material.name.az) return material.name.az;
      if (material.name.en) return material.name.en;
      if (material.name.ru) return material.name.ru;
      
      // If name has text property (e.g., { text: "..." })
      if (material.name.text) return material.name.text;
      
      // Try to get name from translations object if available
      if (material.name.translations) {
        if (material.name.translations.az) return material.name.translations.az;
        if (material.name.translations.en) return material.name.translations.en;
        if (material.name.translations.ru) return material.name.translations.ru;
      }
    }
    
    // Try direct properties if name object doesn't have language fields
    if (material.az) return material.az;
    if (material.en) return material.en;
    if (material.ru) return material.ru;
    if (material.text) return material.text;
    
    // Fallback
    return "Unknown Material";
  };

  // Helper function to check if a category already has a selected material
  const getCategorySelectedMaterial = (categoryId) => {
    // Ensure selectedRoom and categoryId are valid
    if (!selectedRoom || !categoryId) {
      console.log(`Invalid selectedRoom (${selectedRoom}) or categoryId (${categoryId})`);
      return null;
    }
    
    // Check if we have data in selectedCategories state
    if (!selectedCategories[selectedRoom]) {
      console.log(`No selected categories for room ${selectedRoom}`);
      return null;
    }
    
    // Return the material ID for this category
    const materialId = selectedCategories[selectedRoom][categoryId];
    console.log(`Selected material for category ${categoryId} in room ${selectedRoom}: ${materialId || 'none'}`);
    return materialId;
  };

  // Modify the renderSelectedMaterials function to use mono-files endpoint directly
  const renderSelectedMaterials = () => {
    if (!selectedRoom || !selectedMaterial.roomTypes) {
      return (
        <div className="empty-materials">
          <p>{t("material.noMaterialsSelected")}</p>
        </div>
      );
    }

    // Find the current room's materials and area
    const currentRoom = selectedMaterial.roomTypes.find(
      room => room.roomType === selectedRoom
    );

    // Get room area from roomValues
    const roomData = JSON.parse(sessionStorage.getItem("roomValues") || "[]")
      .find(room => room.name === selectedRoom);
    
    const roomArea = roomData ? parseFloat(roomData.area) : 0;

    if (!currentRoom || !currentRoom.materials || currentRoom.materials.length === 0) {
      return (
        <div className="empty-materials">
          <p>{t("material.noMaterialsSelected")}</p>
        </div>
      );
    }

    // Just display all materials - don't group them by materialId
    return (
      <div className="selected-materials-grid">
        {currentRoom.materials.map((material) => {
          // Get material image if available - the selected materials might have image references
          // from the original API response
          let imageSrc = null;
          
          try {
            // Get material image using path property directly
            imageSrc = DefaultWall;
            
            // Log material image data for debugging
            console.log(`Selected material ${material.id} image data:`, {
              imagePath: material.image?.path,
              imageId: material.image?._id
            });
            
            // DIRECT PATH APPROACH: Use image.path property with getImageUrl
            if (material.image && material.image.path) {
              imageSrc = getImageUrl(material.image);
              console.log(`Using direct path for selected material: ${imageSrc}`);
            }
            // Fallback to imageOnRoom path
            else if (material.imageOnRoom && material.imageOnRoom.path) {
              imageSrc = getImageUrl(material.imageOnRoom);
              console.log(`Using imageOnRoom path for selected material: ${imageSrc}`);
            }
          } catch (err) {
            console.error('Error getting material image:', err);
            imageSrc = DefaultWall;
          }
          
          // Special handling for doors and windows
          if (material.materialId === 'door-material' || material.materialId === 'window-material') {
            return (
              <div key={material.id} className="material-card">
                <div className="material-img-container">
                  <img 
                    src={imageSrc} 
                    alt={getDisplayName(material)} 
                    className="material-img" 
                    onError={(e) => {
                      console.log('Image load failed, using fallback');
                      e.target.src = DefaultWall;
                    }}
                  />
                </div>
                <div className="material-card-content">
                  <h4>{getDisplayName(material)}</h4>
                  <div className="material-price">
                    {material.price} {material.currency || 'AZN'} × {material.count}
                  </div>
                </div>
                <button 
                  className="remove-btn" 
                  onClick={() => handleRemoveMaterial(material.id)}
                  title={t("material.remove")}
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            );
          }

          // Regular materials
          return (
            <div key={material.id} className="material-card">
              <div className="material-img-container">
                <img 
                  src={imageSrc} 
                  alt={getDisplayName(material)} 
                  className="material-img" 
                  onError={(e) => {
                    console.log("Image load error, using fallback");
                    e.target.src = DefaultWall;
                  }}
                />
              </div>
              <div className="material-card-content">
                <h4>{getDisplayName(material)}</h4>
                <div className="material-price">
                  {material.price} {material.currency || 'AZN'} × {material.count || 1}
                </div>
              </div>
              <button 
                className="remove-btn" 
                onClick={() => handleRemoveMaterial(material.id)}
                title={t("material.remove")}
              >
                <i className="bi bi-trash"></i>
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  // Malzeme silme işlevi - güncellenmiş
  const handleRemoveMaterial = (materialId) => {
    console.log(`Attempting to remove material with ID: ${materialId}`);
    
    setSelectedMaterial(prev => {
      const newState = {
        roomTypes: prev.roomTypes.map(room => {
          if (room.roomType === selectedRoom) {
            // Find the material to be removed by its id (not materialId)
            const materialToRemove = room.materials.find(m => m.id === materialId);
            
            if (!materialToRemove) {
              console.log(`Could not find material with ID ${materialId} in room ${selectedRoom}`);
              return room;
            }
            
            // If material exists and has a category, update the selectedCategories state
            if (materialToRemove.categoryId) {
              // Get the category ID
              const categoryId = materialToRemove.categoryId;
              
              setSelectedCategories(prev => {
                const updated = {...prev};
                if (updated[selectedRoom] && updated[selectedRoom][categoryId]) {
                  delete updated[selectedRoom][categoryId];
                }
                return updated;
              });
              
              console.log(`Removed category ${materialToRemove.categoryId} from selected categories`);
            } 
            // If it has categories array, try to get category from there
            else if (materialToRemove.categories && materialToRemove.categories.length > 0) {
              // Get the category ID
              let categoryId = null;
              const category = materialToRemove.categories[0];
              
              if (typeof category === 'string') {
                categoryId = category;
              } else if (category && (category.id || category._id)) {
                categoryId = category.id || category._id;
              }
              
              if (categoryId) {
                setSelectedCategories(prev => {
                  const updated = {...prev};
                  if (updated[selectedRoom] && updated[selectedRoom][categoryId]) {
                    delete updated[selectedRoom][categoryId];
                  }
                  return updated;
                });
                
                console.log(`Removed category ${categoryId} from selected categories`);
              }
            }
            
            return {
              ...room,
              // Remove the material with the specified ID
              materials: room.materials.filter(m => m.id !== materialId)
            };
          }
          return room;
        })
      };

      // Save to session storage
      sessionStorage.setItem('selectedMaterial', JSON.stringify(newState));
      console.log('Material removed, new state:', newState);
      
      return newState;
    });

    toast.success(t("material.materialRemoved"));
  };

  // Load initial values from session storage
  useEffect(() => {
    // Load roomValues from sessionStorage immediately on mount
    const storedRoomValues = JSON.parse(sessionStorage.getItem('roomValues') || '[]');
    setRoomValues(storedRoomValues);
    console.log('Loaded roomValues from sessionStorage:', storedRoomValues);
  }, []);

  // Add useEffect to update room visualization based on selected materials
  useEffect(() => {
    if (!selectedRoom || !selectedMaterial.roomTypes || Object.keys(categoryRoomMapping).length === 0) {
      // Reset to defaults if no room selected or no mapping available
      setCeilingImage(DefaultCeiling);
      setWallImage(DefaultWall);
      setFloorImage(DefaultFloor);
      console.log("Reset room visualization to defaults - no room/mapping");
      return;
    }
    
    // Find materials for current room
    const currentRoom = selectedMaterial.roomTypes.find(room => room.roomType === selectedRoom);
    if (!currentRoom || !currentRoom.materials || currentRoom.materials.length === 0) {
      // Reset to defaults if no materials in current room
      setCeilingImage(DefaultCeiling);
      setWallImage(DefaultWall);
      setFloorImage(DefaultFloor);
      console.log("Reset room visualization to defaults - no materials in room");
      return;
    }
    
    console.log("Updating room visualization based on selected materials");
    
    // Group materials by room part using mapping
    const materialsByRoomPart = {
      ceiling: null,
      wall: null,
      floor: null
    };
    
    // Find materials for each room part using the mapping
    for (const material of currentRoom.materials) {
      // Skip door and window materials
      if (material.materialId === 'door-material' || material.materialId === 'window-material') {
        continue;
      }
      
      if (!material.categories || material.categories.length === 0) continue;
      
      const category = material.categories[0];
      if (!category) continue;
      
      const categoryId = category.id || category._id;
      const categoryMapping = categoryRoomMapping[categoryId];
      
      if (categoryMapping) {
        const roomPart = categoryMapping.roomPart;
        console.log(`Material ${material.id} mapped to ${roomPart} via category ${categoryId} (${categoryMapping.categoryName})`);
        
        // Use the most recent material for each room part (last one wins)
        materialsByRoomPart[roomPart] = material;
      } else {
        // Fallback to name-based detection
        const categoryName = category.name?.text || category.name?.az || category.name?.en || category.name || '';
        const roomPart = determineRoomPartFromCategory(categoryName);
        
        if (roomPart) {
          console.log(`Material ${material.id} mapped to ${roomPart} via fallback name detection (${categoryName})`);
          materialsByRoomPart[roomPart] = material;
        } else {
          console.log(`Could not map material ${material.id} to any room part. Category: ${categoryName} (${categoryId})`);
        }
      }
    }
    
    // First reset all to defaults
    setCeilingImage(DefaultCeiling);
    setWallImage(DefaultWall);
    setFloorImage(DefaultFloor);
    console.log("Reset all room parts to defaults first");
    
    // Then update only the parts that have materials
    Object.entries(materialsByRoomPart).forEach(([roomPart, material]) => {
      if (!material) return;
      
      const imageUrl = material.imageOnRoom ? 
        getImageUrl(material.imageOnRoom) : 
        (material.image ? getImageUrl(material.image) : null);
        
      if (imageUrl) {
        switch (roomPart) {
          case 'ceiling':
            console.log('Setting ceiling image from useEffect to:', imageUrl);
            setCeilingImage(imageUrl);
            break;
          case 'wall':
            console.log('Setting wall image from useEffect to:', imageUrl);
            setWallImage(imageUrl);
            break;
          case 'floor':
            console.log('Setting floor image from useEffect to:', imageUrl);
        setFloorImage(imageUrl);
            break;
      }
    }
    });
  }, [selectedMaterial, selectedRoom, categoryRoomMapping]);

  // Debug: Track when selectedCategories changes
  useEffect(() => {
    console.log("selectedCategories state updated:", selectedCategories);
  }, [selectedCategories]);
  
  // Debug: Track when selectedMaterial changes
  useEffect(() => {
    if (selectedMaterial && selectedMaterial.roomTypes) {
      console.log("selectedMaterial state updated:", selectedMaterial);
    }
  }, [selectedMaterial]);

  return (
    <div className="material-section px-3">
      <Header
        title={headerTitle}
        showProfileIcon={true}
        showBackIcon={true}
        onBackClick={() => navigate(backwardNavigate)}
      />
      <style jsx="true">{`
        .selected-material-item {
          position: relative;
        }
        
        .delete-material-btn {
          position: absolute;
          top: 5px;
          right: 5px;
          background-color: rgba(255, 0, 0, 0.7);
          color: white;
          border: none;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0.8;
          transition: opacity 0.3s ease;
        }
        
        .delete-material-btn:hover {
          opacity: 1;
        }

        .wall-section {
          position: relative;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        
        .wall-background {
          width: 100%;
          display: block;
        }
        
        .wall-foreground {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;
          pointer-events: none;
        }
        
        /* Dropdown section styling */
        .dropdown-section {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1000;
          display: flex;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.5);
          padding: 0;
          overflow: hidden;
          max-height: 80vh;
          height: 80vh; /* Fixed height */
          backdrop-filter: blur(5px); /* Blur background */
        }
        
        .dropdown-content {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 16px;
          padding: 60px 24px 24px 24px; /* Extra padding at top for close button */
          width: 100%;
          max-width: 1200px; /* Limit width on large screens */
          max-height: 80vh;
          overflow-y: auto;
          background-color: white;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
          animation: slideUp 0.3s ease;
          position: relative;
        }
        
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
        
        .dropdown-close {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
          background-color: #f5f5f5;
          border: none;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          z-index: 5;
          color: #333;
          font-size: 20px;
          transition: all 0.2s ease;
        }
        
        .dropdown-close:hover {
          background-color: #e6e6e6;
          transform: scale(1.05);
        }
        
        @media (max-width: 768px) {
          .dropdown-content {
            grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
            padding: 60px 16px 16px 16px;
            gap: 12px;
          }
          
          .dropdown-section {
            height: 90vh;
            max-height: 90vh;
          }
        }
        
        .dropdown-content .btn {
          padding: 0;
          border: none;
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          transition: transform 0.2s, box-shadow 0.2s;
          height: 100%;
          text-align: left;
          overflow: hidden;
          position: relative;
        }
        
        .dropdown-content .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.12);
        }
        
        .dropdown-content .btn.selected {
          border: 3px solid #7B7D51;
          box-shadow: 0 4px 12px rgba(123, 125, 81, 0.3);
        }
        
        .dropdown-content .btn.category-occupied {
          opacity: 0.7;
        }
        
        .dropdown-content .btn.category-occupied:hover {
          opacity: 0.9;
        }
        
        .selected-indicator {
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: #7B7D51;
          color: white;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 3;
          box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        }
        
        .selected-indicator i {
          font-size: 18px;
        }
        
        .material-box {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
          border-radius: 12px;
          overflow: hidden;
        }
        
        .material-box img {
          width: 100%;
          height: 120px;
          object-fit: cover;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          background-color: #f5f5f5;
        }
        
        .material-box h5 {
          font-size: 14px;
          font-weight: 600;
          margin: 0;
          padding: 10px 12px 6px;
          color: #333;
          line-height: 1.3;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          min-height: 45px;
        }
        
        .material-box p {
          font-size: 15px;
          font-weight: 600;
          margin: 0;
          padding: 0 12px 12px;
          color: #7B7D51;
        }
        
        .no-materials {
          grid-column: 1 / -1;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 150px;
          background-color: #f9f9f9;
          border-radius: 8px;
          color: #888;
          font-style: italic;
          margin: 10px 0;
        }
        
        /* 2-column grid layout */
        .selected-materials-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          margin-top: 15px;
          width: 100%;
        }
        
        @media (max-width: 768px) {
          .selected-materials-grid {
            grid-template-columns: 1fr;
          }
          
          .dropdown-content {
            grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          }
        }
        
        /* Material card */
        .material-card {
          display: flex;
          flex-direction: column;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
          padding: 6px;
          position: relative;
          height: 100%;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        
        .material-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        }
        
        /* Image container */
        .material-img-container {
          width: 100%;
          height: 150px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f5f5f5;
          position: relative;
        }
        
        .material-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
        
        .dropdown-content .btn:hover .material-img {
          transform: scale(1.05);
        }
        
        /* Content */
        .material-card-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 12px;
        }
        
        .material-card h4 {
          margin: 0 0 8px 0;
          font-size: 15px;
          font-weight: 600;
          color: #333;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          min-height: 42px;
        }
        
        .material-price {
          font-size: 16px;
          font-weight: 700;
          color: #7B7D51;
          margin-top: 8px;
        }
        
        /* Material card */
        .material-card {
          display: flex;
          flex-direction: column;
          background-color: white;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          padding: 0;
          position: relative;
          height: 100%;
          transition: transform 0.2s, box-shadow 0.2s;
          overflow: hidden;
        }
        
        .material-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
        }
        
        /* Remove button */
        .remove-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.9);
          border: none;
          color: #ff5757;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
          z-index: 5;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
        }
        
        .remove-btn:hover {
          background-color: #ff5757;
          color: white;
        }
        
        .empty-materials {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100px;
          background-color: #f9f9f9;
          border-radius: 8px;
          margin-top: 15px;
          grid-column: 1 / -1;
        }
        
        .empty-materials p {
          color: #888;
          font-style: italic;
        }
        
        .room-name {
          font-size: 18px;
          margin-bottom: 10px;
          color: #333;
          border-bottom: 2px solid #7B7D51;
          padding-bottom: 8px;
          display: inline-block;
        }
        
        .selected-materials-title {
          font-size: 20px;
          margin: 25px 0 15px;
          color: #333;
        }
        
        .error-material {
          grid-column: span 1;
          background-color: #fff1f1;
          border: 1px solid #ffdbdb;
          border-radius: 8px;
          padding: 15px;
          color: #d32f2f;
          text-align: center;
        }
        
        .material-content {
          padding: 12px;
          display: flex;
          flex-direction: column;
          flex: 1;
        }
        
        .material-content h5 {
          font-size: 15px;
          font-weight: 600;
          margin: 0 0 8px 0;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          min-height: 40px;
          line-height: 1.4;
        }
        
        .already-selected-badge {
          position: absolute;
          top: 10px;
          left: 10px;
          background-color: rgba(255, 162, 0, 0.9);
          color: white;
          font-size: 12px;
          font-weight: 600;
          padding: 4px 8px;
          border-radius: 4px;
          z-index: 3;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        
        .dropdown-content .btn.category-occupied .material-img-container::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.1);
          z-index: 2;
        }
        
        .dropdown-content .btn.selected .material-img-container::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(123, 125, 81, 0.1);
          z-index: 2;
        }

        /* New Modal Styles - Mobile optimized with 2x2 grid */
        .material-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 1000;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          backdrop-filter: blur(4px);
          animation: fadeIn 0.2s ease;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .material-modal {
          width: 100%;
          background: white;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          box-shadow: 0 -5px 25px rgba(0, 0, 0, 0.15);
          max-height: 80vh;
          display: flex;
          flex-direction: column;
          animation: slideUp 0.3s ease-out;
          transform-origin: bottom center;
        }
        
        @keyframes slideUp {
          from { 
            transform: translateY(100%); 
            opacity: 0.8;
          }
          to { 
            transform: translateY(0); 
            opacity: 1;
          }
        }
        
        .material-modal-header {
          padding: 12px 20px;
          border-bottom: 1px solid #f0f0f0;
          display: flex;
          align-items: center;
          position: relative;
          justify-content: center;
        }
        
        .modal-indicator {
          width: 40px;
          height: 5px;
          background: #e0e0e0;
          border-radius: 3px;
          position: absolute;
          top: 8px;
          left: 50%;
          transform: translateX(-50%);
        }
        
        .material-modal-header h4 {
          margin: 14px 0 4px;
          font-size: 16px;
          font-weight: 600;
          color: #333;
          padding: 0 20px;
          text-align: center;
        }
        
        .modal-close-btn {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          font-size: 22px;
          color: #777;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
        }
        
        .modal-close-btn:hover {
          background-color: #f5f5f5;
          color: #333;
        }
        
        .material-modal-content {
          flex: 1;
          overflow-y: auto;
          padding: 16px;
          -webkit-overflow-scrolling: touch;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
        }
        
        .modal-loader {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 200px;
        }
        
        /* Mobile-first styles for material grid - consistent 2x2x2 layout */
        .material-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          width: 100%;
          box-sizing: border-box;
        }
        
        @media (min-width: 768px) {
          .material-modal {
            max-width: 600px; /* Narrower to maintain 2 column layout */
            max-height: 80vh;
            border-radius: 20px;
            margin-bottom: 20px;
          }
          
          .material-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }
        }
        
        .material-item {
          border-radius: 12px;
          overflow: hidden;
          background: white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          transition: all 0.2s ease;
          cursor: pointer;
          position: relative;
          display: flex;
          flex-direction: column;
          height: 100%;
          border: 1px solid #eee;
          aspect-ratio: 0.8;
        }
        
        .material-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
        }
        
        .material-item.selected {
          border: 2px solid #7B7D51;
          box-shadow: 0 4px 15px rgba(123, 125, 81, 0.2);
        }
        
        /* Update the styling for selected materials in the modal */
        .material-modal .material-item.selected {
          border: 2px solid #4CAF50;
          box-shadow: 0 4px 12px rgba(76, 175, 80, 0.2);
          position: relative;
        }
        
        .material-modal .material-item.selected::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border: 1px solid #4CAF50;
          pointer-events: none;
        }
        
        .material-item.other-selected {
          opacity: 0.75;
        }
        
        .material-image {
          position: relative;
          height: 120px;
          overflow: hidden;
        }
        
        .material-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
        
        .material-item:hover .material-image img {
          transform: scale(1.07);
        }
        
        .material-details {
          padding: 10px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        
        .material-details h5 {
          margin: 0 0 6px;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.3;
          min-height: 36px;
        }
        
        .material-price {
          display: flex;
          align-items: baseline;
          margin-top: 4px;
        }
        
        .material-price span {
          font-size: 16px;
          font-weight: 700;
          color: #7B7D51;
          margin-right: 4px;
        }
        
        .material-price small {
          font-size: 12px;
          color: #777;
        }
        
        .selection-mark {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 26px;
          height: 26px;
          background: #7B7D51;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
          z-index: 2;
          font-size: 14px;
        }
        
        .selection-indicator {
          position: absolute;
          top: 10px;
          left: 10px;
          background: rgba(255, 153, 0, 0.85);
          font-size: 10px;
          font-weight: 600;
          color: white;
          padding: 3px 6px;
          border-radius: 4px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
          z-index: 2;
        }
        
        .no-materials {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 200px;
          color: #888;
          text-align: center;
          padding: 20px;
        }
        
        .no-materials i {
          font-size: 40px;
          margin-bottom: 15px;
          color: #ddd;
        }
        
        /* Small screen optimizations */
        @media (max-width: 380px) {
          .material-image {
            height: 110px;
          }
          
          .material-details h5 {
            font-size: 13px;
            min-height: 36px;
          }
          
          .material-price span {
            font-size: 14px;
          }
          
          .material-grid {
            gap: 10px;
            padding: 0 2px;
          }
          
          .material-modal-content {
            padding: 12px 10px;
          }
          
          .selection-mark {
            width: 24px;
            height: 24px;
            font-size: 12px;
          }
          
          .selection-indicator {
            font-size: 9px;
            padding: 2px 5px;
          }
        }
        
        /* Handle shorter screens */
        @media (max-height: 700px) {
          .material-modal {
            max-height: 85vh;
          }
          
          .material-image {
            height: 100px;
          }
        }
      `}</style>
      <>
        <div className="top-section">
          <div className="room-handle-section mb-4">
            <RoomDropdown
              onChange={handleRoomChange}
              selectedRoomTypes={selectedRoomTypes}
            />
          </div>
          <div className="image-on-room-section">
            {showFullRoomImage ? (
              <img src={roomImage} alt="Room" className="full-room-image" />
            ) : (
              <>
                <div className="ceiling-section">
                  <img src={ceilingImage} alt="Ceiling" />
                </div>
                <div className="wall-section">
                  <img src={wallImage} alt="Wall" className="wall-background" />
                  <img src={WallForeground} alt="Wall Foreground" className="wall-foreground" />
                </div>
                <div className="floor-section">
                  <img src={floorImage} alt="Floor" />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="middle-section">
          <div className="material-category-buttons gap-3">
            {materialCategory?.map((type) => (
              <button
                key={type.id}
                className="btn"
                onClick={() => handleSectionClick(type.id)}
                style={{
                  cursor: !selectedRoom ? "not-allowed" : "pointer",
                  opacity: !selectedRoom ? 0.5 : 1,
                }}
              >
                {type.name.text}
              </button>
            ))}
          </div>
        </div>
        {activeSection && (
          <div 
            ref={dropdownRef} 
            className="material-modal-overlay"
            onClick={() => setActiveSection(null)} // Close modal when clicking outside
          >
            <div 
              className="material-modal"
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
            >
              <div className="material-modal-header">
                <div className="modal-indicator"></div>
                <h4>{materialCategory.find(cat => cat.id === activeSection)?.name?.text || 'Materyal Seçimi'}</h4>
                <button className="modal-close-btn" onClick={() => setActiveSection(null)}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              <div className="material-modal-content">
                {loading ? (
                  <div className="modal-loader">
                    <SquareLoader color="#7B7D51" size={50} speedMultiplier={1} />
                  </div>
                ) : (
                  <>
                    {material && material.length > 0 ? (
                      (() => {
                        console.log("Filtering materials for category:", activeSection);
                        const filteredMaterials = material.filter((item) => {
                          if (!item || !item.categories) {
                            console.log("Skipping item without categories:", item?.id || "unknown");
                            return false;
                          }
                          
                          // Simplified category matching logic to handle all potential structures
                          const matchesCategory = item.categories.some(category => {
                            // Handle direct string values
                            if (typeof category === 'string') {
                              return category === activeSection;
                            }
                            
                            // Handle object with id or _id
                            if (category.id === activeSection || category._id === activeSection) {
                              return true;
                            }
                            
                            return false;
                          });
                          
                          return matchesCategory;
                        });
                        
                        console.log(`Found ${filteredMaterials.length} materials matching category ${activeSection}`);
                        
                        if (filteredMaterials.length === 0) {
                          return (
                            <div className="no-materials">
                              <i className="bi bi-exclamation-circle"></i>
                              <p>{t("material.21")}</p>
                            </div>
                          );
                        }
                        
                        return (
                          <div className="material-grid">
                            {filteredMaterials.map((item) => {
                              try {
                                // Get the material ID consistently
                                const materialId = item.id || item._id;
                                console.log("Rendering material:", materialId, getDisplayName(item));
                                
                                // Log raw image data for debugging
                                console.log(`Material ${materialId} raw image data:`, {
                                  _id: item._id,
                                  imagePath: item.image?.path,
                                  imageId: item.image?._id
                                });
                                
                                // DIRECT PATH APPROACH: Use image.path directly to bypass mono-files
                                let imageUrl = null;
                                
                                if (item.image && item.image.path) {
                                  // Use getImageUrl with the path property directly
                                  imageUrl = getImageUrl(item.image);
                                  console.log(`Using direct path approach for ${materialId}: ${imageUrl}`);
                                }
                                // Fallback to imageOnRoom path
                                else if (item.imageOnRoom && item.imageOnRoom.path) {
                                  imageUrl = getImageUrl(item.imageOnRoom);
                                  console.log(`Using imageOnRoom path for ${materialId}: ${imageUrl}`);
                                }
                                // Last resort: Use default image
                                else {
                                  imageUrl = DefaultWall;
                                  console.log(`No valid path for ${materialId}, using default wall`);
                                }
                                
                                // Fiyat hesaplama
                                const price =
                                  selectedRepairTariff.id === 1
                                    ? item.lowPrice
                                    : selectedRepairTariff.id === 2
                                    ? item.midPrice
                                    : selectedRepairTariff.id === 3
                                    ? item.highPrice
                                    : item.price;
                                    
                                // Get category ID consistently
                                let categoryId = null;
                                if (item.categories && item.categories.length > 0) {
                                  const category = item.categories[0];
                                  if (typeof category === 'string') {
                                    categoryId = category;
                                  } else if (category && (category.id || category._id)) {
                                    categoryId = category.id || category._id;
                                  }
                                }
                                
                                if (!categoryId) {
                                  console.warn("Material without valid category ID:", item);
                                  return null;
                                }
                                
                                // Check if this material is selected
                                const selectedMaterialInCategory = getCategorySelectedMaterial(categoryId);
                                const isSelected = selectedMaterialInCategory === materialId;
                                // Remove or modify the isOtherSelected condition
                                // Only show "Seçilmiş" when this exact material is selected
                                // const isOtherSelected = selectedMaterialInCategory && selectedMaterialInCategory !== materialId;

                                const displayName = getDisplayName(item) || t("material.28");

                                return (
                                  <div 
                                    key={materialId}
                                    className={`material-item ${isSelected ? 'selected' : ''}`}
                                    onClick={() => handleMaterialSelect(item)}
                                  >
                                    <div className="material-image">
                                      <img 
                                        src={imageUrl} 
                                        alt={displayName} 
                                        onError={(e) => {
                                          console.error(`Image load failed for ${materialId}, falling back to default:`, e.target.src);
                                          e.target.src = DefaultWall;
                                        }}
                                      />
                                      {isSelected && (
                                        <div className="selection-mark">
                                          <i className="bi bi-check-lg"></i>
                                        </div>
                                      )}
                                      {/* Remove this badge since it's showing incorrectly */}
                                      {/* {isOtherSelected && (
                                        <div className="selection-indicator">Seçilmiş</div>
                                      )} */}
                                    </div>
                                    <div className="material-details">
                                      <h5>{displayName}</h5>
                                      <div className="material-price">
                                        <span>{price || 0} {item.currency || "AZN"}</span>
                                        <small>/ m²</small>
                                      </div>
                                    </div>
                                  </div>
                                );
                              } catch (error) {
                                console.error("Material rendering error for item:", item?.id || "unknown", error);
                                return null;
                              }
                            })}
                          </div>
                        );
                      })()
                    ) : (
                      <div className="no-materials">
                        <i className="bi bi-exclamation-circle"></i>
                        <p>{t("material.21")}</p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="button-section">
          <button className="btn py-3 global-button" onClick={postRepairData}>
            {t("material.9")}
          </button>
        </div>
        {/* Selected Materials Section */}
        <div className="selected-materials-section">
          <h3 className="selected-materials-title">{t("material.27")}</h3>
          <div className="room-materials">
            <h4 className="room-name">{selectedRoom}</h4>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <SquareLoader color="#cda742" size={50} speedMultiplier={1} />
              </div>
            ) : (
              renderSelectedMaterials()
            )}
          </div>
        </div>{" "}
      </>
    </div>
  );
};

export default Material;
